<template>
  <div id="app">
    <!--导航条-->
    <gheader></gheader>
    <!--logo一行-->
    <glogo></glogo>
    <!--红色导航-->
    <grednav></grednav>
    <!--主要内容展示-->
    <div class="row-content">
      <div class="main-width">
        <div class="contact-info" style="margin-bottom: 100px;">
          <div class="form-group shanghai">
            <p><span>{{companyname}}</span></p>
            <div>
              <p><span>联系部门：</span>{{department}}</p>
              <p><span>联系邮箱：</span>{{email}}</p>
              <p><span>联系电话：</span>{{telephone}}</p>
              <p><span>信件邮寄地址：</span>{{address}}</p>
              <p><span>邮编：</span>{{postCode}}</p>
              <div class="address-box" style="padding-right: 500px; text-align:center;">
                <img src="static/imgs/szMap.png" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--footer-->
    <gfooter id="contact-footer"></gfooter>
  </div>
</template>

<script>
  /*eslint-disable*/
  import gheader from 'components/G-header'
  import glogo from 'components/G-logo'
  import grednav from 'components/G-rednav'
  import gsupplier from 'components/G-supplier'
  import gfooter from 'components/G-footer'
  import lnav from 'components/L-nav'
  import map1 from 'components/map1'
  import map2 from 'components/map2'
  import map3 from 'components/map3'
  import {apiLinks} from '../../api/links'

  export default {
    name: 'app',
    components: {
      gheader,
      glogo,
      grednav,
      gsupplier,
      gfooter,
      lnav,
      map1,
      map2,
      map3
    },
    data () {
      return {
        logourl: apiLinks.logourl,
        companyname: apiLinks.companyfullname,
        telephone: apiLinks.telephone,
        address: apiLinks.address,
        email: apiLinks.email,
        postCode: apiLinks.postCode,
        department: apiLinks.department,
        links: {
          title: '友情链接',
          content: [
            '南方水泥官方网站',
            '中国建筑材料集团有限公司',
            '中国建材股份有限公司',
            '南方水泥有限公司成员企业'
          ]
        },
        infos: {
          enquiryCount: '登录后可见',
          bidCount: '登录后可见',
          supCount: '登录后可见',
          bidMoney: '登录后可见',
          purCount: '登录后可见'
        },

      }
    },
    mounted () {
      let url = apiLinks.contact
      //后续再改
      if(window.localStorage.user){
        this.$http.jsonp(url, []).then(function (response) {
          this.infos = response.data[0]['result']
          this.infos.enquiryCount+='条'
          this.infos.bidCount+='次'
          this.infos.supCount+='次'
          this.infos.bidMoney+='元'
          this.infos.purCount+='次'
        }, function (response) {
        })
      }
    }
  }
</script>
<style>
  @import 'contact.css';
</style>



// WEBPACK FOOTER //
// contact.vue?793d2764